import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-lock-icon',
  templateUrl: './general-lock.component.html'
})
export class GeneralLockComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
